import type { ReactNode } from 'react';
import { useRouter } from '@tanstack/react-router';
import { useSession } from '@portal/platform/session';
import { AppShell } from '@portal/ui';
import { Brand } from './brand';
import { DEFAULT_PINS, useNavBadges } from './nav-badges';

/** The dealer portal's frame around every logged-in page. */
export function DealerShell({ children }: { children: ReactNode }) {
  const session = useSession();
  const router = useRouter();
  const badges = useNavBadges();
  const logout = async () => {
    await session.logout();
    await router.navigate({ href: '/login' });
  };
  return (
    // Pages not ported yet stay in the menu and land on the legacy placeholder.
    <AppShell
      brand={<Brand />}
      onLogout={() => void logout()}
      keepUnmatched
      defaultPins={DEFAULT_PINS}
      badges={badges}
    >
      {children}
    </AppShell>
  );
}
